/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BulkOperationResultDisplay_bulkOperationResult$ref = any;
export type BulkOperationResultDisplay_bulkOperationResult = {
    readonly itemsSucceeded: ReadonlyArray<{
        readonly title: string | null;
        readonly serviceId: string | null;
        readonly hasRequestedHoldForBuyer: boolean | null;
        readonly projects: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly name: string | null;
        } | null> | null;
    } | null> | null;
    readonly itemsFailed: ReadonlyArray<{
        readonly title: string | null;
        readonly serviceId: string | null;
        readonly projects: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly name: string | null;
        } | null> | null;
    } | null> | null;
    readonly failureCodes: ReadonlyArray<{
        readonly itemId: string | null;
        readonly failureCode: string | null;
    } | null> | null;
    readonly " $refType": BulkOperationResultDisplay_bulkOperationResult$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "projects",
        "storageKey": null,
        "args": [
            {
                "kind": "Variable",
                "name": "userId",
                "variableName": "userId"
            }
        ],
        "concreteType": "Project",
        "plural": true,
        "selections": [
            (v1 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
            }
        ]
    } as any);
    return {
        "kind": "Fragment",
        "name": "BulkOperationResultDisplay_bulkOperationResult",
        "type": "BulkOperationResult",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            }
        ],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "itemsSucceeded",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasRequestedHoldForBuyer",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "buyerId",
                                "variableName": "userId"
                            }
                        ],
                        "storageKey": null
                    },
                    (v2 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "itemsFailed",
                "storageKey": null,
                "args": null,
                "concreteType": "Item",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    (v2 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "failureCodes",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemRequestFailureCode",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "itemId",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "failureCode",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '869efcf2e8fc500f3f2ab7912f7fbc07';
export default node;
